import PropTypes from "prop-types";
import AuthorInfo from "./components/AuthorInfo/component";
import TimeStamp from "../../../TimeStamp/component";
import { createDepartmentsMarkup } from "./utils";

/**
 * Card metadata, e.g. author, timestamp, etc.
 *
 * @param {Object} props The component props
 * @returns {JSX.Element} The Metadata component
 */
export function Metadata({
    showTimestamp = true,
    departments = {
        sectionList: null,
        sectionLabels: null,
    },
    updated = 1,
    displayComments = false,
    authorName,
    authorImage,
    hideAuthorInfo,
    baseSection,
    subSection,
    path,
    id,
}) {
    // Show the timestamp, unless it does not have an updated time
    let timeStamp = null;

    if (showTimestamp && updated) {
        timeStamp = <TimeStamp updated={updated} />;
    }

    // Show the author information if at least the name is given.
    let authorInfo = null;
    if (authorName && !hideAuthorInfo) {
        authorInfo = <AuthorInfo name={authorName} image={authorImage} />;
    }

    const metadataDepartments = createDepartmentsMarkup(
        baseSection,
        subSection,
        path,
        departments
    );
    const separator =
        timeStamp && metadataDepartments?.length ? (
            <span className="metaSeparator" aria-hidden="true">
                |
            </span>
        ) : null;

    // Display comment counts if required(landing page only) and available(story is enabled for commenting)
    const commentIcon = (
        <svg
            viewBox="0 0 32 32"
            focusable="false"
            role="img"
            aria-label="Open for comments"
        >
            <path d="M20.95,17H11a1,1,0,0,0,0,2h10a1,1,0,0,0,0-2Zm2-6H9a1,1,0,0,0,0,2h14a1,1,0,0,0,0-2ZM16,0C7.14,0,0,6.26,0,14a12.55,12.55,0,0,0,6,10.9v7.07l7-4.25a18.71,18.71,0,0,0,3,.25c8.82,0,16-6.25,16-14S24.78,0,16,0Zm0,25.95a16.29,16.29,0,0,1-3.37-.37l-4.7,2.82.06-4.63A11.56,11.56,0,0,1,2,14C2,7.36,8.24,2,16,2s14,5.36,14,12-6.26,12-14,12Zm0,0" />
        </svg>
    );
    const commentInfo = displayComments ? (
        <span className="commentInfo">
            <span className="metaSeparator" aria-hidden="true">
                |
            </span>
            <span className="commentCount-icon">{commentIcon}</span>
        </span>
    ) : null;
    return (
        <div id={id} className="metadata" data-testid="metadata">
            {authorInfo}
            <div className="metadataText">
                {metadataDepartments}
                {separator}
                {timeStamp}
                {commentInfo}
            </div>
        </div>
    );
}

Metadata.propTypes = {
    published: PropTypes.number,
    updated: PropTypes.number,
    showTimestamp: PropTypes.bool,
    id: PropTypes.string,
    authorName: PropTypes.string,
    authorImage: PropTypes.string,
    departments: PropTypes.object,
    baseSection: PropTypes.string,
    subSection: PropTypes.string,
    displayComments: PropTypes.bool,
};

export default Metadata;
